<template>
  <q-page padding class="window-height window-width row justify-center items-center">
    <div class="column full-width">
      <div class="row">

      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4 offset-md-4">
          <q-card dark :bordered="!isMobile" :flat="isMobile"
                  :class="{ 'shadow-4': !isMobile, 'q-pa-lg': !isMobile, 'q-pa-sm': isMobile }">
            <h5 class="text-h5 text-white q-my-md text-center">Password Reset</h5>
            <p class="text-bold text-body1 text-center text-negative">{{ error }}</p>
            <q-form
              ref="formRef"
              @submit="onSubmit"
              @reset="onReset"
              class="q-gutter-md q-mt-md"
            >
              <q-input
                ref="passwordRef"
                dark
                filled
                standout
                color="secondary"
                v-model="password"
                type="password"
                label="New Password"
                lazy-rules
                autofocus
                :rules="fieldPasswordRules"
              />

              <q-input
                ref="confirmPasswordRef"
                dark
                filled
                standout
                color="secondary"
                v-model="confirmPassword"
                type="password"
                label="Confirm New Password"
                lazy-rules
                :rules="fieldConfirmRules"
              />

              <div class="q-mt-md">
                <q-btn label="Submit" type="submit" color="secondary" class="full-width" :loading="loading" size="lg"/>
              </div>
            </q-form>
            <q-card-actions>
            </q-card-actions>
          </q-card>
          <h5 class="text-body2 text-white q-my-md text-center">Remembered your password? <span class="text-secondary text-bold cursor-pointer" @click="onSignIn">Sign in here</span></h5>
        </div>
      </div>
      <div class="row">
        <div class="col">

        </div>
      </div>
    </div>
  </q-page>
</template>
<script>
import { ref } from "vue"
import { useRouter, useRoute } from "vue-router"
import { loggerFactory } from '../../logger'
import { useUserStore } from '../../stores/user-store'
import { useQuasar } from "quasar"
import {track} from "../../rum";

const logger = loggerFactory("LoginPage")
export default {
  name: "LoginPage",
  setup() {
    const $q = useQuasar()
    const isMobile = $q.platform.is.mobile
    const router = useRouter()
    const currentRoute = useRoute()
    const store = useUserStore()
    const error = ref(null)
    const formRef = ref(null)
    const password = ref(null)
    const passwordRef = ref(null)
    const confirmPassword = ref(null)
    const confirmPasswordRef = ref(null)
    const loading = ref(false)
    const code = ref(currentRoute.query?.oobCode)

    const fieldPasswordRules = ref([
      val => !!val || "Password is required"
    ])

    const fieldConfirmRules = ref([
      val => val === password.value || `Password must match.`
    ])

    const notifyError = (message) => {
      $q.notify({ type: "negative", message: message, timeout: 2500 })
    }

    const onSubmit = () => {
      logger.debug("Validate passwords")
      formRef.value.validate().then((success) => {
        if(success) {
          loading.value = true
          track("change_password")
          const finalPassword = password.value.trim()
          store.changePassword(code.value, finalPassword)
            .then(() => {
              track("change_password_success")
              logger.debug("Successfully reset credentials...")
              router.replace({ path: "/auth/login" })
            })
            .catch((err) => {
              track("change_password_failure", { message: err.message })
              error.value = err.message
            })
            .finally(() => loading.value = true)
        } else {
          notifyError("Invalid password or passwords didn't match.")
        }
      })
    }

    const onReset = () => {
      formRef.value.resetValidation()
    }

    const onSignIn = () => {
      router.replace({ path: '/auth/login' })
    }

    return {
      isMobile,
      error,
      formRef,
      password,
      passwordRef,
      confirmPassword,
      confirmPasswordRef,
      loading,
      fieldPasswordRules,
      fieldConfirmRules,
      onSubmit,
      onReset,
      onSignIn
    }
  }
}
</script>

<style scoped>

</style>
